import axios from 'axios';

const config = {
  withCredentials: true,
  xsrfHeaderName: 'X-CSRF-Token',
  'Content-Type': 'multipart/form-data',
};

export default axios.create(config);
